<template>
  <v-row>
    <v-col sm="6">
      <v-checkbox label="Élements présents" v-model="present"></v-checkbox>
    </v-col>
    <v-col sm="6">
      <v-checkbox label="Élements sortis" v-model="deleted"></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  mounted() {
    this.setQuery({
      query: {
        bool: {
          must_not: {
            exists: {
              field: "deletedDate"
            }
          }
        }
      }
    });
  },
  data: () => ({
    present: true,
    deleted: false
  }),
  props: ["setQuery", "aggregations"],
  watch: {
    present: function(present) {
      let query = {};
      if (!this.deleted) {
        if (present) {
          query = {
            query: {
              bool: {
                must_not: {
                  exists: {
                    field: "deletedDate"
                  }
                }
              }
            }
          };
        } else {
          query = {
            query: {
              bool: {
                must: {
                  exists: {
                    field: "fake-field"
                  }
                }
              }
            }
          };
        }
      } else {
        if (present) {
          query = {};
        } else {
          query = {
            query: {
              bool: {
                must: {
                  exists: {
                    field: "deletedDate"
                  }
                }
              }
            }
          };
        }
      }

      this.$props.setQuery({
        query,
        value: present
      });
    },
    deleted: function(deleted) {
      let query = {};
      if (!this.present) {
        if (deleted) {
          query = {
            query: {
              bool: {
                must: {
                  exists: {
                    field: "deletedDate"
                  }
                }
              }
            }
          };
        } else {
          query = {
            query: {
              bool: {
                must: {
                  exists: {
                    field: "fake-field"
                  }
                }
              }
            }
          };
        }
      } else {
        if (deleted) {
          query = {};
        } else {
          query = {
            query: {
              bool: {
                must_not: {
                  exists: {
                    field: "deletedDate"
                  }
                }
              }
            }
          };
        }
      }

      this.$props.setQuery({
        query,
        value: deleted
      });
    }
  }
};
</script>